var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"building-banner"},[_c('img',{staticClass:"img",style:([_vm.style]),attrs:{"src":("https://cdn.vip-wifi.com/fangchan/img/building/" + _vm.img_path),"mode":"aspectFill"},on:{"click":_vm.tapImg}})])}
var staticRenderFns = []

export { render, staticRenderFns }